import React, { useEffect, useState } from 'react'
import DashboardWrapper from "../../layout/index";
import BarChartMulti from '../../components/BarChartMultiple';
import { getAnalyticsMatrics } from '../../api/dashobard';
import { useTranslation } from "react-i18next";
import Filter from "../../assets/icons/Filter.svg";
import Close from "../../assets/close-circle.svg";
import Loader from "../../components/Loader";
import { formatDate, formatNumberWithoutFraction } from "../../utility";
import TimeFrameSelector from "../../components/TimeFrameSelector";
import { formatCurrentEndDate, formatCurrentStartDate } from "../../utility";
import { getGlobalFilter } from "../../api/filters";
import PieChart from "../../components/PieChart";
import { preseller, salesman } from "../../utility/constant";

interface CartonItemProps {
  color: string;
  label: string;
  value: any;
}


const Index = () => {
  const [formattedAalytic, setFormateedAnanlytic] = useState<any>([])
  const [ksaTarget, setTargetKsa] = useState<any>([])
  const [timeFrame, setSelectTimeFrame] = useState<any>("Today");
  const { t } = useTranslation();
  const [startDate, setStartDate] = useState<any | undefined>(getCurrentDate());
  const [endDate, setEndDate] = useState<any | undefined>(getCurrentDate());
  const [open, setOpen] = useState(false);
  const [loadingFilter, setLoadingFilter] = useState<boolean>(false);
  const [globalFilters, setGlobalFilters] = useState<any>(null);
  const [salesOffice, setSelectedSalesOffice] = useState<any>("");
  const [salesRegion, setSelectedSalesRegion] = useState<any>([]);
  const [dataLoader, setDataLoader] = useState<boolean>(false);

  const handleClearFilters = () => {
    const defaultStartDate = getCurrentDate();
    const defaultEndDate = getCurrentDate();

    setStartDate(defaultStartDate);
    setEndDate(defaultEndDate);
    setSelectTimeFrame("Today");
    handleClearApply(defaultStartDate, defaultEndDate);
  };

  const handleClearApply = (startDate: string, endDate: string) => {
    setOpen(false);

    const data: any = {};
    if (startDate) {
      data["start_date"] = formatCurrentStartDate(new Date(startDate));
    }
    if (endDate) {
      data["end_date"] = formatCurrentEndDate(new Date(endDate));
    }
    data["positions"] = [preseller,salesman];
    getAnalyticsData(data);
  };

  function getCurrentDate() {
    const date = new Date();
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  }

  const handleEndDateChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setEndDate(e.target.value);
    checkTimeFrame(startDate, e.target.value);
  };

  const getAnalyticsData = async (param: any) => {
    setDataLoader(true)
    setFormateedAnanlytic([])
    await getAnalyticsMatrics(param).then((res) => {
      setFormateedAnanlytic(res.data)
      let dataArray: any = [];
      dataArray?.push({
        visits: "Acheived",
        value: Number(res?.data?.targets?.ksa?.achieved_target) || 0,
      },
        {
          visits: "Target",
          value: Number(res.data.targets.ksa.target) || 0,
        })
      setTargetKsa(dataArray)
      setDataLoader(false)
    }).catch((error) => {
      setDataLoader(false)
      console.log(error)
    })
  }

  const checkTimeFrame = (start: any, end: any) => {
    if (start === formatDate(new Date()) && end === formatDate(new Date())) {
      setSelectTimeFrame("Today");
    } else if (
      start === formatDate(new Date().setDate(new Date().getDate() - 1)) &&
      end === formatDate(new Date().setDate(new Date().getDate() - 1))
    ) {
      setSelectTimeFrame("Yesterday");
    } else if (
      start === formatDate(new Date().setDate(1)) &&
      end === formatDate(new Date())
    ) {
      setSelectTimeFrame("Month Till Date");
    } else {
      setSelectTimeFrame("");
    }
  };

  const getGlobalFilters = async (data: any) => {
    try {
      if (loadingFilter) {
        return;
      }
      setLoadingFilter(true);
      const response = await getGlobalFilter(data);
      setGlobalFilters(response);
    } catch (error) {
      console.error("Error fetching global filters:", error);
    } finally {
      setLoadingFilter(false);
    }
  };

  const handleFiltersUpdate = () => {
    const data: any = {};

    if (salesRegion.length > 0) {
      data["regions"] = salesRegion;
    }
    if (salesOffice.length > 0) {
      data["sales_office_ids"] = salesOffice;
    }

    data["endpoint"] = "visit-summary";
    data["start_date"] = formatCurrentStartDate(new Date(startDate));
    data["end_date"] = formatCurrentEndDate(new Date(endDate));
    data["positions"] = [preseller, salesman];
    getGlobalFilters(data);
  };

  const handleStartDateChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setStartDate(e.target.value);
    checkTimeFrame(e.target.value, endDate);
  };

  const handleApply = () => {
    setOpen(false);
    const data: any = {};
    if (startDate) {
      data["start_date"] = formatCurrentStartDate(new Date(startDate));
    }
    if (startDate) {
      data["end_date"] = formatCurrentEndDate(new Date(endDate));
    }
    if (startDate) {
      data["group_by_sales_office"] = false;
    }
    if (salesRegion.length > 0) {
      data["regions"] = salesRegion;
    }
    if (salesOffice) {
      data["sales_office_ids"] = salesOffice;
    }
    data["positions"] = [preseller, salesman];
    getAnalyticsData(data);

  };

  useEffect(() => {
    const data: any = {};

    if (startDate) {
      data["start_date"] = formatCurrentStartDate(new Date(startDate));
    }
    if (startDate) {
      data["end_date"] = formatCurrentEndDate(new Date(endDate));
    }
    if (startDate) {
      data["group_by_sales_office"] = false;
    }
    if (salesRegion.length > 0) {
      data["regions"] = salesRegion;
    }
    if (salesOffice) {
      data["sales_office_ids"] = salesOffice;
    }
    data["positions"] = [preseller, salesman];
    getAnalyticsData(data)
  }, [])


  useEffect(() => {
    const data: any = {};

    if (salesRegion.length > 0) {
      data["regions"] = salesRegion;
    }
    if (salesOffice) {
      data["sales_office_ids"] = salesOffice;
    }

    data["endpoint"] = "dashboard";
    data["start_date"] = formatCurrentStartDate(new Date(startDate));
    data["end_date"] = formatCurrentEndDate(new Date(endDate));
    data["positions"] = [preseller, salesman];
    getGlobalFilters(data);
  }, []);

  const pieChartForCancelledPo = [
    {
      name: "Confirm PO Qty",
      value: formatNumberWithoutFraction(formattedAalytic?.po_metrics?.ksa?.confirmed_po_count) || 0,
      color: "#00C48C",
      id: "Confirm PO Qty",
    },
    {
      name: "Delivered PO Qty",
      color: "#FFAA2A",
      value: formatNumberWithoutFraction(formattedAalytic?.po_metrics?.ksa?.delivered_po_count) || 0,
      id: "Delivered PO Qty",
    },
    {
      name: "Cancelled PO Qty",
      value: formatNumberWithoutFraction(formattedAalytic?.po_metrics?.ksa?.cancelled_po_count) || 0,
      color: "#FF4D68",
      id: "Cancelled PO Qty",
    },
  ];

  const pieChartForCancelledCarton = [
    {
      name: "Confirm Cartons Qty",
      value: formatNumberWithoutFraction(formattedAalytic?.po_metrics?.ksa.confirmed_cartons_qty) || 0,
      color: "#00C48C",
      id: "Confirm Cartons Qty",
    },
    {
      name: "Delivered Cartons Qty",
      value: formatNumberWithoutFraction(formattedAalytic?.po_metrics?.ksa.delivered_cartons_qty) || 0,
      color: "#FFAA2A",
      id: "Delivered Cartons Qty",
    },
    {
      name: "Cancelled Carton Qty",
      value: formatNumberWithoutFraction(formattedAalytic?.po_metrics?.ksa.cancelled_cartons_qty) || 0,
      color: "#FF4D68",
      id: "Cancelled Carton Qty",
    },
  ];


  const getFormattedCartonsData = (item: any) => {
    const data = [
      {
        name: "Confirm Cartons Qty",
        value: formatNumberWithoutFraction(item?.confirmed_cartons_qty) || 0,
        color: "#00C48C",
        id: "Confirm Cartons Qty",
      },
      {
        name: "Delivered Cartons Qty",
        value: formatNumberWithoutFraction(item?.delivered_cartons_qty) || 0,
        color: "#FFAA2A",
        id: "Delivered Cartons Qty",
      },
      {
        name: "Cancelled Carton Qty",
        value: formatNumberWithoutFraction(item?.cancelled_cartons_qty) || 0,
        color: "#FF4D68",
        id: "Cancelled Carton Qty",
      },
    ];
    return data || []

  }

  const getFormattedPoData = (item: any) => {
    const data = [
      {
        name: "Confirm PO Qty",
        value: formatNumberWithoutFraction(item?.confirmed_po_count) || 0,
        color: "#00C48C",
        id: "Confirm PO Qty",
      },
      {
        name: "Delivered PO Qty",
        color: "#FFAA2A",
        value: formatNumberWithoutFraction(item?.delivered_po_count) || 0,
        id: "Delivered PO Qty",
      },
      {
        name: "Cancelled PO Qty",
        value: formatNumberWithoutFraction(item?.cancelled_po_count) || 0,
        color: "#FF4D68",
        id: "Cancelled PO Qty",
      },
    ];
    return data
  }

  const CartonItem: React.FC<CartonItemProps> = ({ color, label, value }) => {
    return (
      <div className="flex items-center gap-2">
        <span
          className="w-3 h-3 rounded-full"
          style={{ backgroundColor: color }}
        ></span>
        <span className=" text-gray-700 text-[13px] font-semibold">{label}:</span>
        <span className="text-gray-900 text-[13px] font-semibold">{(value)}</span>
      </div>
    );
  };

  return (
    <DashboardWrapper>
      <>
        {dataLoader && (
          <div className="absolute top-[50%] left-[50%] z-50">
            <Loader />
            <p>Loading Please Wait...</p>
          </div>
        )}
        <div className="flex justify-between items-center px-6 " style={dataLoader ? { filter: 'blur(5px)' } : {}}>
          <div className="flex flex-col gap-1 pl-1 pb-3 text-13 font-medium ">
            <p className=''>{t("DashboardAnalytics.reportTitle")}</p>
            <p className="text-[20px] font-semibold">
              {timeFrame ? (
                <>
                  {timeFrame === "Today" && t("DashboardAnalytics.today")}
                  {timeFrame === "Yesterday" &&
                    t("timeframeselector.yesterday")}
                  {timeFrame === "Month Till Date" &&
                    t("DashboardAnalytics.monthtilldate")}
                </>
              ) : (
                startDate?.split("-").reverse().join("-") +
                " To " +
                endDate?.split("-").reverse().join("-")
              )}
            </p>
          </div>
          <div>
            <button
              className="flex items-center px-4 p-3 gap-2 bg-[#FAFAFA] border-2 border-[#EBEBEB]"
              onClick={() => setOpen(true)}
            >
              <img src={Filter} alt="" />{" "}
              {t("DashboardAnalytics.filterButton")}
            </button>
          </div>
        </div>
      </>
      <div className='flex w-full border-2 bg-[#F5F5F5] p-2 rounded-md flex-col gap-2' style={dataLoader ? { filter: 'blur(5px)' } : {}}>
        <div className='w-full'>
          <div className='p-1  font-semibold'>{t("targetAnalytics.Sales_Matrics")}</div>
          <div className='bg-white border-2  flex gap-4 p-[20px] w-full rounded xl:flex-row flex-col'>
            <div className='w-full xl:w-[30%]'>
              <div className='text-[13px] font-semibold '>{t("targetAnalytics.KSA_Sales_Target")}</div>
              <BarChartMulti sales_offices={Array(formattedAalytic?.targets?.ksa) || []} barColors={["#00C48C", "#FFAA2A", "#FF4D68", "#408BFC"]} />
            </div>
            <div className='w-full xl:w-[70%]'>
              <div className='text-[13px] font-semibold'>{t("targetAnalytics.Sales_Offices_Wis_Target")}</div>
              <BarChartMulti sales_offices={formattedAalytic?.targets?.sales_offices || []} barColors={["#00C48C", "#FFAA2A", "#FF4D68", "#408BFC"]} />
            </div>
          </div>
        </div>
        <div className='w-full flex flex-col gap-4'>
          <div className='p-1 font-semibold'>{t("targetAnalytics.po_Matrics")}</div>
          <div className='bg-white border-2 flex gap-4 p-[20px] w-full rounded flex-col xl:flex-row'>
            <div className='w-full'>
              <div className='text-[13px] font-semibold'>{t("targetAnalytics.KSA_PO_Target")}</div>
              <div className='flex gap-2 p-2 justify-center flex-col sm:flex-row'>
                <div className="h-[400px] xl:w-[50%] flex justify-center flex-col flex-1">
                  <PieChart data={pieChartForCancelledCarton} />
                  <p className='pb-4 text-[13px] font-semibold'>{t("targetAnalytics.carton_qty")}</p>
                  {pieChartForCancelledCarton.map((item) =>
                    <CartonItem color={item.color} label={item.name} value={item.value} />)
                  }
                  <div> </div>
                </div>
                <div className="h-[400px] xl:w-[50%] flex justify-center flex-col flex-1 w-full">
                  <PieChart data={pieChartForCancelledPo} />
                  <p className='pb-4 text-[13px] font-semibold'>{t("targetAnalytics.po_qty")}</p>
                  {pieChartForCancelledPo.map((item) =>
                    <CartonItem color={item.color} label={item.name} value={item.value} />)
                  }
                </div>

              </div>
            </div>

          </div>
          <div className='w-full bg-white border-2'>
            <div className='p-2 text-[13px] font-semibold'>{t("targetAnalytics.Sales_Offices_Wise_PO_Target")}</div>
            <div className='flex flex-wrap '>
              {formattedAalytic?.po_metrics?.sales_offices.map((item: any) =>
                <div className='xl:w-1/2 w-full  p-4 '>
                  <div className='pt-4 pl-2'>{item.sales_office_name}</div>
                  <div className='flex gap-2 p-2 justify-center flex-col sm:flex-row'>
                    <div className="h-[400px] xl:w-[50%] w-full flex justify-center flex-col flex-1">
                      <PieChart data={getFormattedCartonsData(item)} />
                      <p className='pb-4'>Carton Qty</p>
                      {getFormattedCartonsData(item)?.map((item) =>
                        <CartonItem color={item.color} label={item.name} value={item.value} />)
                      }
                      <div> </div>
                    </div>
                    <div className="h-[400px] xl:w-[50%] w-full flex justify-center flex-col flex-1">
                      <PieChart data={getFormattedPoData(item)} />
                      <p className='pb-4'>PO Qty</p>
                      {getFormattedPoData(item)?.map((item) =>
                        <CartonItem color={item.color} label={item.name} value={item.value} />)
                      }
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
      {open && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-end sm:items-start items-center z-50">
          <div className="bg-white shadow-lg w-full max-w-md h-full">
            <div className="flex justify-between p-6 border-b-2">
              <div className="text-16 font-bold">
                {t("DashboardAnalytics.filtersTitle")}
              </div>
              <div>
                <img
                  className="cursor-pointer"
                  onClick={() => setOpen(false)}
                  src={Close}
                  alt=""
                />
              </div>
            </div>
            <div className="flex flex-col justify-between h-[calc(100vh-100px)] px-12 pt-6  overflow-y-auto">
              <div className="relative flex flex-col gap-[30px]">
                <div className="absolute z-30 top-[50%] left-[45%]">
                  {loadingFilter && <Loader />}
                </div>
                {/* <div className="flex flex-col sm:flex-row gap-4 w-full">
                  <div className="w-1/2">
                    <DropdownMulti
                      label={t("visitreports.filters.region")}
                      options={globalFilters?.regions.map((sales: any) => ({
                        value: sales,
                        label: sales,
                      }))}
                      selectedValues={salesRegion}
                      onClose={handleFiltersUpdate}
                      onChange={setSelectedSalesRegion}
                      placeholder={t("visitreports.filters.selectRegion")}
                    />
                  </div>
                  <div className="w-1/2">
                    <DropdownMulti
                      label={t("visitreports.filters.salesOffice")}
                      options={
                        globalFilters?.sales_offices.map((sales: any) => ({
                          value: sales.id,
                          label: sales.name,
                        })) || []
                      }
                      selectedValues={salesOffice}
                      onClose={handleFiltersUpdate}
                      onChange={setSelectedSalesOffice}
                      disabled={salesRegion.length === 0 || loadingFilter}
                      placeholder={t(
                        "visitreports.filters.selectSalesOffice"
                      )}
                    />
                  </div>
                </div> */}
                <div className="date-range-picker">
                  <div className="flex flex-col sm:flex-row gap-4 w-full">
                    <div className="w-1/2">
                      <label className="block text-10 text-gray-500 pb-1">
                        {t("DashboardAnalytics.startDateLabel")}
                      </label>
                      <input
                        type="date"
                        className="rounded p-2 border-2 border-gray-400 w-full"
                        value={startDate}
                        onChange={handleStartDateChange}
                        onKeyDown={(e) => e.preventDefault()}
                        max={new Date(endDate).toISOString().split("T")[0]}
                        min={(() => {
                          const end = new Date(endDate);
                          const minDate = new Date(end);
                          minDate.setDate(end.getDate() - 30);
                          return minDate > new Date(0) ? minDate.toISOString().split("T")[0] : '1970-01-01';
                        })()}
                      />
                    </div>
                    <div className="w-1/2">
                      <label className="block text-10 text-gray-500 pb-1">
                        {t("DashboardAnalytics.endDateLabel")}
                      </label>
                      <input
                        type="date"
                        className="rounded p-2 border-2 border-gray-400 w-full"
                        value={endDate}
                        onChange={handleEndDateChange}
                        onKeyDown={(e) => e.preventDefault()}
                        max={new Date().toISOString().split("T")[0]}
                        min={new Date(startDate).toISOString().split("T")[0]}
                      />
                    </div>
                  </div>
                </div>
                <div>
                  <TimeFrameSelector
                    customClass="w-full border border-gray-300 rounded p-2"
                    setSelectTimeFrame={setSelectTimeFrame}
                    timeFrame={timeFrame}
                    setStartDate={setStartDate}
                    setEndDate={setEndDate}
                  />
                </div>
              </div>

              <div className="flex justify-between mt-4">
                <button
                  onClick={handleClearFilters}
                  className="px-4 py-2 text-black bg-gray-200 rounded transition duration-200 hover:bg-gray-300"
                >
                  {t("DashboardAnalytics.clearFilterButton")}
                </button>
                <button
                  onClick={() => handleApply()}
                  className="px-4 py-2 text-white bg-purple rounded transition duration-200 hover:bg-[#F3E6F4] hover:text-purple"
                >
                  {t("DashboardAnalytics.applyFilterButton")}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </DashboardWrapper>
  )
}

export default Index